module.exports = require("@handsontable/vue");